import { Plugin } from './Plugin';
import { LightingPlugin } from './LightingPlugin';
import { ScenePlugin } from './ScenePlugin';
import { Object3D, Vector3, DirectionalLightHelper, Mesh, BoxGeometry, MeshBasicMaterial } from 'three';

const PI2 = Math.PI * 2;

export class SunPlugin extends Plugin{
	constructor(manager){
		super(manager);
		this.dependencies.add(ScenePlugin);
		this.dependencies.add(LightingPlugin);
		
		this._rotation 	= 0;
		this._height 	= 9;

	}

	attach(){
		this.manager.get(ScenePlugin).on('scene-changed', this.onSceneChanged)
	}

	detach(){
		this.manager.get(ScenePlugin).off('scene-changed', this.onSceneChanged)
	}

	update(){
		this.lightingPlugin.setLight({
			type:"directional",
			name:"directional",
			color:0xffffff,
			intensity:2,
			position:{
				x:Math.sin(this.rotation) * 9,
				z:Math.cos(this.rotation) * 9,
				y:this.height
			}
		});
	}

	get lightingPlugin(){ return this.manager.get(LightingPlugin); }

	get rotation(){ return this._rotation; }
	set rotation(rotation){
		if(this._rotation != rotation && rotation >= 0 && rotation <= PI2){
			this._rotation = rotation;

			this.updatePosition();
		}
	}

	get height(){ return this._height; }
	set height(height){
		if(this._height != height && height >= 0){
			this._height = height;

			this.updatePosition();
		}
	}

	updatePosition = () => {
		const light = this.lightingPlugin.lights.get('directional');

		light.position.set(
			Math.sin(this.rotation) * 9,
			this.height,
			Math.cos(this.rotation) * 9
		);


		this.manager.viewer.requestRender();
	}

	onSceneChanged = (scene) => {
		if(scene){
			this.height = scene.data.sun_y;
			this.rotation = scene.data.sun_rotation;
			return;
		}
		this.rotation = 0;
		this.height   = 9;
	}
}